import { jsxs as s, Fragment as u, jsx as e } from "react/jsx-runtime";
import { attributes as d } from "../utils/attributes.js";
import { LogoInverse as h } from "../Logo/LogoInverse.js";
import { useEffect as p } from "react";
import { Backdrop as N } from "../Backdrop/Backdrop.js";
import '../../assets/Menu.css';function w({
  expanded: a,
  onClose: n,
  onOpen: t,
  items: i,
  className: c = "",
  version: l = ""
}) {
  p(() => {
    a && t && t();
  }, [a, t]);
  const o = (r, m) => {
    switch (r.type) {
      case "separator":
        return /* @__PURE__ */ e("hr", { className: "menu-item-separator" }, m);
      case "menu-title":
        return /* @__PURE__ */ e("small", { className: "menu-title", children: r.title }, r.title);
      case "menu-item":
        return /* @__PURE__ */ e(r.Component, { onClick: n, className: "menu-item" }, m);
    }
  };
  return /* @__PURE__ */ s(u, { children: [
    /* @__PURE__ */ e(N, { onClose: n, open: a }),
    /* @__PURE__ */ e(
      "aside",
      {
        className: `menu ${c}`,
        ...d({ "aria-expanded": a }),
        children: /* @__PURE__ */ s("div", { className: "menu-container", children: [
          /* @__PURE__ */ s("div", { className: "menu-header", children: [
            /* @__PURE__ */ e(h, { width: 50 }),
            /* @__PURE__ */ e("span", { className: "menu-separator", children: "|" }),
            /* @__PURE__ */ e("span", { className: "menu-name", children: "Codex" }),
            /* @__PURE__ */ s("span", { className: "menu-state", children: [
              "ALPHA ",
              l
            ] })
          ] }),
          /* @__PURE__ */ e("div", { className: "menu-items", children: i.map((r, m) => o(r, m)) })
        ] })
      }
    )
  ] });
}
export {
  w as Menu
};
//# sourceMappingURL=Menu.js.map
